import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from '@sicapes/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class IScppg {
    id?: number;

    static fromJson(jsonData: any): IScppg {
        return Object.assign(new IScppg(), jsonData);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScppgServicosService extends BaseResourceService<IScppg> {

    constructor(protected injector: Injector) {
        super('rest/inscricoes/scppg', injector, IScppg.fromJson);
    }

    /**
     * Lista os Programas de Pós-Graduação coordenados pelo CPF informado.
     * Retorno envelopado: { programas: [] } (vazio quando o CPF não coordena nenhum PPG).
     */
    public obterProgramasPorCoordenador(cpf: string): Observable<{ programas: any[] }> {
        return this.http.get<{ programas: any[] }>(this.apiPath + `/programas/coordenador/${cpf}`)
            .pipe(
                catchError(this.handleError)
            );
    }

    /**
     * Obtém os dados de um Programa de Pós-Graduação pelo seu id.
     * Retorno envelopado: { programas: [] } — o consumidor pega o primeiro item.
     */
    public obterProgramaPorId(idPrograma: number | string): Observable<{ programas: any[] }> {
        return this.http.get<{ programas: any[] }>(this.apiPath + `/programas/${idPrograma}`)
            .pipe(
                catchError(this.handleError)
            );
    }

    /**
     * Obtém as Disciplinas vinculadas ao Programa.
     * Retorno envelopado: { disciplinas: [] }.
     * O SCPPG responde 404 ("Entity not found") quando o programa não possui
     * disciplinas cadastradas — isso não é erro, é lista vazia.
     */
    public obterDisciplinasPorPrograma(idPrograma: number | string): Observable<{ disciplinas: any[] }> {
        return this.http.get<{ disciplinas: any[] }>(this.apiPath + `/disciplinas/${idPrograma}`)
            .pipe(
                catchError((error: any) => this.tratarErroComoListaVazia(error, { disciplinas: [] }))
            );
    }

    /**
     * Obtém as Linhas de Pesquisa vinculadas ao Programa.
     * Retorno envelopado: { linhasPesquisa: [] }.
     * O SCPPG responde 404 ("Entity not found") quando o programa não possui
     * linhas de pesquisa cadastradas — isso não é erro, é lista vazia.
     */
    public obterLinhasPesquisaPorPrograma(idPrograma: number | string): Observable<{ linhasPesquisa: any[] }> {
        return this.http.get<{ linhasPesquisa: any[] }>(this.apiPath + `/linhas-pesquisa/${idPrograma}`)
            .pipe(
                catchError((error: any) => this.tratarErroComoListaVazia(error, { linhasPesquisa: [] }))
            );
    }

    /**
     * Converte o 404 do SCPPG em um envelope vazio; os demais erros seguem
     * pelo tratamento padrão.
     */
    private tratarErroComoListaVazia<T>(error: any, vazio: T): Observable<T> {
        if (error?.status === 404) {
            return of(vazio);
        }
        return this.handleError(error);
    }
}
